import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";

const useStyles = makeStyles((theme) => ({
    deleteBtn: {
        background: theme.palette.error.dark,
            color: theme.palette.getContrastText(theme.palette.error.dark),
        },
}));

const HazardControlDeleteDialog = ({
    isOpen,
    setIsOpen,
    hazardControl,
    updateControl,

}) => {
    const classes = useStyles();
    const [hazardControlText, setHazardControlText] = useState("");

    useEffect(() => {
        if (hazardControl) {
            setHazardControlText(hazardControl?.control?.name);
        }
    }, [hazardControl]);

    const handleConfirm = async e => {
        e.preventDefault();
        updateControl({ controlId: hazardControl?.id, hazardControlText, isCustomHazard: hazardControl?.control?.isCustomHazard, isCustomControl: hazardControl?.isCustomControl })
        handleClose();
    }

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Remove control?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    "{hazardControlText}" will be removed from this review. Previous reviews still show it.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button className={classes.deleteBtn} onClick={handleConfirm} variant="contained" color="primary">
                    Remove
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default HazardControlDeleteDialog;
